module.exports = __webpack_public_path__ + "media/images/app/homepage/weddings/brides-banner-mobile-c5c0dc5d698dd4f531f25eb46709f34d.webp";